<template>
	<v-card :loading="loading?'primary':false">
		<v-card-text>
			<!-- <v-divider></v-divider> -->
			<v-item-group  v-model="infoToFilter.videosSelected">
				<!-- multiple -->
				<v-container fluid class="pt-0 overflow-y-auto">
					<v-row dense class="fill-height" style="max-height: 300px;">
						<v-col 
							v-for  	= "(itemVideo, idxVideo) of infoToFilter.videos" 
							:key 	= "'list_video_sidebar' + idxVideo + itemVideo.uuid" 
							cols 	= "auto"  
						>
							<!-- @click 	="sel(n)"  -->
							<v-item v-slot:default = "{ active, toggle }" :value="itemVideo">
								<v-card 
									dark  
									outlined
									:color 	= "active  ? 'primary'  : itemVideo.isValid ? 'success': itemVideo.isInvalid ? 'error':  '' "  
									style 	= "width:100%; height: 100%;"  									 
									class 	= "pl-0 ma-0" 									
								>	
									<v-card-title class = "pa-0 ma-0 secodary justify-space-between" style = "font-size: 70%; line-height: 110%">
										<!-- <v-spacer></v-spacer> -->
										<span> {{ itemVideo.date }}</span>

										<v-tooltip top>
											<template v-slot:activator = "{ on }">
												<v-btn
													fab												
													color   = "error"
													@click  = "confirmDelete(itemVideo)"
													width   = "20"
													height  = "20" 
													v-on 	= "on"
												>
													<v-icon small color="white"> mdi-delete </v-icon>
												</v-btn>
											</template>
											<span> {{ $ml.get('delete') }} </span>		
										</v-tooltip>
									</v-card-title>																		
									<v-card-text class="pa-1 mb-0">		
									<v-row no-gutters>
									<v-col cols="12">									
			              <video  
			                class="video-preview"
					            muted
					            controls 
					            preload="metadata"
					            :key="'itemSidebarVideo'+itemVideo.uuid"
					            :ref="'video_' + idxVideo"
					            @loadedmetadata="setPreviewFrame($event, idxVideo)"
					            :src="itemVideo.urlVideoPreload || renderUrlVideo(itemVideo)"
					        	></video>
										</v-col>
										<v-col>											         
      								<v-icon small v-show="!itemVideo.loadingBlob  ">mdi-face-recognition</v-icon>      								      								      		
											<span class="caption"> 
												{{itemVideo.msg	}}
											</span>
										</v-col>
									      								<!-- Enhanced loading indicators -->
      								<div v-show="itemVideo.loadingBlob && itemVideo.loadingProgress < 100" class="d-flex align-center">
      									<v-progress-circular 
      										:width="3" 
      										:size="15" 
      										class="mt-0 mr-1" 
      										:indeterminate="!itemVideo.loadingProgress"
      										:value="itemVideo.loadingProgress"
      										color="success"
      									></v-progress-circular>
      									<span class="caption" v-if="itemVideo.loadingProgress">
      										{{ itemVideo.loadingProgress }}%
      									</span>
      								</div>
									</v-row>
										<!-- <v-spacer></v-spacer> -->
									</v-card-text>							                  
							            
					        <v-card-actions class="pa-0" style = "font-size: 80%; line-height: 110%">
					          <!-- <span> # {{idxVideo + 1}}</span> -->
					          <v-btn x-small color="success" class="ml-auto mr-1 mb-1" @click="toggleVideo(toggle, itemVideo)"> {{ active ? $ml.get('deselect'):$ml.get('select') }} </v-btn>
										<v-btn x-small color="primary" class="ml-auto mr-1 mb-1" @click="openVideo(itemVideo)">{{$ml.get('see_more')}}</v-btn>
					        </v-card-actions>										             	
								</v-card>
							</v-item>
						</v-col>
					</v-row>	
				</v-container>
					
			</v-item-group>
			<v-divider></v-divider>
		</v-card-text>
		<v-card-actions class="text-h5 pa-0">
			<strong class=" mt-2">			
				# {{  infoToFilter.videos.length }}
			</strong>
			<v-spacer></v-spacer>
			
				
				<!-- {{$ml.get('import')}} -->
					<!-- style="max-width: 150px;width: 200px;" -->
				<UploadFile
					:infoUpload="infoToFilter"
				></UploadFile>
			<!-- </v-btn> -->
		</v-card-actions>
	</v-card>
</template>
<style scoped>
.video-preview {
  width: 100%;
  height: auto;
  cursor: pointer;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  background: #000;
}
.video-preview:hover {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}
</style>
<script type="text/javascript">
	import UploadFile from "@/components/face/UploadVideoSearch.vue"
	export default{
		name: "SidebarFaces",
		props:["infoToFilter", "open"],
		components:{UploadFile},
		data: ()=>({
			loading:false,
			messageErrorUpload: [],
			infoItem : null,
			videoObservers: new Map(), // Store intersection observers for each video
			failedVideos: new Set(), // Track videos that have failed to load to prevent retry spam
		}),
		mounted(){
			this.getList();
		},
		beforeDestroy(){
			// Clean up blob URLs to prevent memory leaks
			if(this.infoToFilter && this.infoToFilter.videos){
				this.infoToFilter.videos.forEach(video => {
					if(video.urlVideoPreload && video.urlVideoPreload.startsWith('blob:')){
						URL.revokeObjectURL(video.urlVideoPreload);
						video.urlVideoPreload = null;
					}
					// Clean up loading states
					video.loadingBlob = false;
					video.loading = false;
				});
			}
			// Clean up intersection observers
			this.videoObservers.forEach(observer => observer.disconnect());
			this.videoObservers.clear();
			// Clear failed videos tracking
			this.failedVideos.clear();
		},
		methods:{
			confirmDelete(item){
				this.infoItem = item;
				this.$EventBus.$emit("notifications_modal",{ type : "confirm_delete", ID: "SidebarVideoDatabaseDelete", Action: this.deleteItem})
			},
			renderUrlVideo(item){
				if(item){
					// console.log("URL video ", item)
					if(item.id){
						// For videos with ID, return direct URL initially
						// Blob loading will be triggered by intersection observer when visible
						return item.urlVideoPreload || this.$URL+item.url;
					}else if(item?.urlVideo){
						return item.urlVideo;
					}else{
						return item.url;
					}
				}
			},
			triggerFileInput(){				
				this.$refs.uploadImage.$el.querySelector('input[type="file"]').click();
			},
			async deleteItem(val){
				try{
					this.loading=true;
					if(val){

						if(this.infoItem?.id){
							const uri = this.$URL+"/api/v1/videodb/"+this.infoItem.id;
							const res = await this.$axios.delete(uri);
							if(res){
								const idx = this.infoToFilter.videos.indexOf(this.infoItem);
								if(idx>=0){
									// Clean up blob URL before removing the video
									if(this.infoItem.urlVideoPreload && this.infoItem.urlVideoPreload.startsWith('blob:')){
										URL.revokeObjectURL(this.infoItem.urlVideoPreload);
									}
									this.infoToFilter.videos.splice(idx,1);
									// this.infoToFilter.tagsFile.splice(idx,1);
									if(this.infoItem.uuid==this.infoToFilter?.videosSelected?.uuid){
										this.infoToFilter.videosSelected=null;
									}
									this.$EventBus.$emit("notifications_modal", { type : "deleted", message : this.$ml.get("video")})
								}	
							} 
						}else{
							const idx = this.infoToFilter.videos.indexOf(this.infoItem);
							if(idx>=0){
								// Clean up blob URL before removing the video
								if(this.infoItem.urlVideoPreload && this.infoItem.urlVideoPreload.startsWith('blob:')){
									URL.revokeObjectURL(this.infoItem.urlVideoPreload);
								}
								this.infoToFilter.videos.splice(idx,1);
								if(this.infoItem.uuid==this.infoToFilter?.videosSelected?.uuid){
									this.infoToFilter.videosSelected=null;
								}
								// this.infoToFilter.tagsFile.splice(idx,1);
							}
						}
					}

				}catch(error){
					console.warn("Error delete video ", error);
				}finally{
					this.loading=false; 
				}
			},
			toggleVideo(toggle,item){
				toggle();				
				// Solo cargar como blob videos subidos (con uuid), no videos de API (con id)
				if (item.uuid && !item.id && !item.urlVideoPreload && item.needsBlobLoading) {
					console.log('Toggle - Loading uploaded video as blob:', item.uuid);
					this.loadVideoAsBlob(item);
				} else {
					console.log('Toggle - Skipping blob loading for video:', item.id || item.uuid, '- Video de API o ya procesado');
				}
			},	
			setPreviewFrame(event, index) {
      	const video = event.target;
      	video.currentTime = 2; // Cambia al segundo 2
	    },
			async openVideo(item){
				if(item){
					// this.loading=true;
					if(this.infoToFilter.videoUrl){
						URL.revokeObjectURL(this.infoToFilter.videoUrl)
					}
					
					this.infoToFilter.selectedVideoDialog=null
					this.infoToFilter.videoUrl =item.file ? URL.createObjectURL(item.file) : item?.urlVideoPreload ? item?.urlVideoPreload : this.$URL+item.url;					
					this.open.dialogVideo=true;

				}
			},
			async getList(){
				try{
					this.loading=true;
					const uri= this.$URL+"/api/v1/videodb";
					const res = await this.$axios.get(uri)
					if(res && res.data && res.data.rows && res.data.rows.length){
						// console.log(res)
						this.infoToFilter.videos=res.data.rows.map(x=>{
							x.date=this.$Helper.formatDate(x.createdAt, "createdAt", "YYYY-MM-DD HH:mm")
							x.msg=x.total_faces || 0;
							// Reset all loading states for API videos
							x.loadingBlob = false; // Ensure loadingBlob is explicitly false for API-loaded videos
							x.loadingTimeout = false; // Initialize timeout flag
							x.loadingProgress = 100; // Initialize progress tracking
							x.needsBlobLoading = false; // Videos de API no necesitan conversión a blob
							// Clear any existing blob URL
							if(x.urlVideoPreload && x.urlVideoPreload.startsWith('blob:')){
								URL.revokeObjectURL(x.urlVideoPreload);
								x.urlVideoPreload = null;
							}
							return x
						});
						
						// Setup intersection observers for lazy loading after videos are rendered
						this.$nextTick(() => {
							this.setupVideoObservers();
						});
					}
				}catch(error){
					console.warn("Error get list ", error)
				}finally{
					this.loading=false;					
				}
			},
			// Setup intersection observers for all videos
			setupVideoObservers() {
				if (!this.infoToFilter || !this.infoToFilter.videos) return;
				
				this.infoToFilter.videos.forEach((item, index) => {
					const videoRef = this.$refs[`video_${index}`];
					if (videoRef && videoRef[0]) {
						this.setupVideoObserver(videoRef[0], item, index);
					}
				});
			},
			// Method to setup intersection observer for lazy loading
			setupVideoObserver(videoElement, item, index) {
				if (!videoElement || this.videoObservers.has(index)) return;
				
				// Skip if this video has already failed to load
				if (this.failedVideos.has(item.id || item.uuid)) {
					return;
				}
				
				const observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							// Video is visible, load as blob if needed
							console.log('=== VIDEO OBSERVER DEBUG ===');
							console.log('item.id:', item.id);
							console.log('!item.urlVideoPreload:', !item.urlVideoPreload);
							console.log('!item.loadingBlob:', !item.loadingBlob);
							console.log('!this.failedVideos.has(item.id):', !this.failedVideos.has(item.id));
							console.log('item.needsBlobLoading:', item.needsBlobLoading);
							console.log('item.urlVideoPreload:', item.urlVideoPreload);
							console.log('item.loadingBlob:', item.loadingBlob);
							console.log('this.failedVideos.has(item.id):', this.failedVideos.has(item.id));
							console.log('Condition result:', item.id && !item.urlVideoPreload && !item.loadingBlob && !this.failedVideos.has(item.id) && item.needsBlobLoading);
							console.log('========================');
							
							// Solo cargar como blob videos subidos (con uuid), no videos de API (con id)
							if (item.uuid && !item.id && !item.urlVideoPreload && !item.loadingBlob && !this.failedVideos.has(item.uuid)) {
								console.log('Loading uploaded video as blob:', item.uuid);
								this.loadVideoAsBlob(item);
							} else {
								console.log('Skipping blob loading for video:', item.id || item.uuid, '- Video de API o ya procesado');
							}
							// Disconnect observer after loading to avoid repeated calls
							observer.disconnect();
							this.videoObservers.delete(index);
						}
					});
				}, {
					root: null,
					rootMargin: '50px', // Start loading 50px before video becomes visible
					threshold: 0.1
				});
				
				observer.observe(videoElement);
				this.videoObservers.set(index, observer);
			},
			async loadVideoAsBlob(item){
				console.log('=== LOAD VIDEO AS BLOB CALLED ===');
				console.log('item.id:', item.id);
				console.log('item.needsBlobLoading:', item.needsBlobLoading);
				console.log('item.urlVideoPreload:', item.urlVideoPreload);
				console.log('item.loadingBlob:', item.loadingBlob);
				
				// Only load if not already loading or loaded
				if(item.urlVideoPreload || item.loadingBlob) {
					console.log('Skipping - already loaded or loading');
					return;
				}
				
				// Check if this video has already failed to load
				if (this.failedVideos.has(item.id || item.uuid)) {
					console.log('Skipping - video already failed');
					return;
				}
				
				// Check if video needs blob loading
				if (!item.needsBlobLoading) {
					console.log('Skipping - video does not need blob loading');
					return;
				}
				
				console.log('Proceeding with blob loading...');
				item.loadingBlob = true;
				item.loadingProgress = 0;
				item.loadingTimeout = false; // Reset timeout flag
				const videoUrl = this.$URL + item.url;
				
				try {
					// First, get video size to determine loading strategy
					const sizeResponse = await this.getVideoSize(videoUrl);
					const videoSizeMB = sizeResponse / (1024 * 1024);
					
					// Dynamic timeout based on video size (minimum 30s, +10s per 50MB)
					const dynamicTimeout = Math.max(30000, 30000 + (Math.ceil(videoSizeMB / 50) * 10000));
					
					
					
					// Create timeout reference that can be cleared
					let timeoutId = null;
					
					// Add timeout to prevent infinite loading - only if no progress is made
					timeoutId = setTimeout(() => {
						// Only trigger timeout if still loading and no progress has been made
						if(item.loadingBlob && item.loadingProgress === 0) {
							console.warn("Timeout loading video as blob (no progress):", videoUrl);
							item.loadingBlob = false;
							item.urlVideoPreload = null;
							item.loadingTimeout = true;
						}
					}, dynamicTimeout);
					
					// Also set up a progress monitor to clear timeout when progress starts
					const progressMonitor = setInterval(() => {
						if (item.loadingProgress > 0 && timeoutId) {
							//console.log("Progress detected, clearing timeout");
							clearTimeout(timeoutId);
							clearInterval(progressMonitor);
							timeoutId = null;
						}
					}, 1000); // Check every second
					
					// For large videos (>50MB), use streaming approach
					if (videoSizeMB > 50) {
						await this.loadLargeVideoAsBlob(item, videoUrl, timeoutId, progressMonitor);
					} else {
						// For smaller videos, use direct blob loading
						await this.loadSmallVideoAsBlob(item, videoUrl, timeoutId, progressMonitor);
					}
					
				} catch (error) {
					
					item.loadingBlob = false;
					item.loadingTimeout = true;
					// Fallback to direct URL if blob loading fails
					item.urlVideoPreload = null;
					
					// Mark this video as failed to prevent future loading attempts
					this.failedVideos.add(item.id || item.uuid);
					
					// Clean up timeout and progress monitor on error

				}
			},
			
			async getVideoSize(url) {
				try {
					// Method 1: Try HEAD request with CORS settings
					const response = await fetch(url, { 
						method: 'HEAD',
						mode: 'cors',
						credentials: 'omit'
					});
					
					if (response.ok) {
						const contentLength = response.headers.get('content-length');
						return contentLength ? parseInt(contentLength) : 0;
					} else if (response.status === 404) {
						// Video doesn't exist, throw error to be caught by caller
						throw new Error(`Video not found (404): ${url}`);
					}
				} catch (headError) {
					//console.warn("HEAD request failed, trying axios:", headError.message);
					
					try {
						// Method 2: Try with axios
						const response = await this.$axios.head(url, {
							timeout: 5000,
							headers: {
								'Accept': '*/*'
							}
						});
						
						const contentLength = response.headers['content-length'];
						return contentLength ? parseInt(contentLength) : 0;
						
					} catch (axiosError) {
						
						
						// Check if it's a 404 error
						if (axiosError.response && axiosError.response.status === 404) {
							
						}
						
						// Method 3: Try range request to get size
						try {
							const rangeResponse = await fetch(url, {
								headers: { 'Range': 'bytes=0-1' }
							});
							
							if (rangeResponse.status === 404) {
								throw new Error(`Video not found (404): ${url}`);
							}
							
							const contentRange = rangeResponse.headers.get('content-range');
							if (contentRange) {
								const match = contentRange.match(/\/(\d+)/);
								return match ? parseInt(match[1]) : 0;
							}
						} catch (rangeError) {
							
							if (rangeError.message.includes('404')) {
								throw rangeError;
							}
						}
					}
				}
				
				// If all methods fail, return 0 (will use default strategy)
				console.warn("Could not determine video size, using default strategy");
				return 0;
			},
			
			async loadSmallVideoAsBlob(item, videoUrl, timeoutId, progressMonitor) {
				try {
					const res = await this.$Helper.loadVideoBlob(videoUrl);
					
					// Clear timeout and progress monitor on success
					if (timeoutId) {
						clearTimeout(timeoutId);
					}
					if (progressMonitor) {
						clearInterval(progressMonitor);
					}
					
					// Create a blob URL from the response data
					const blob = new Blob([res.data], { type: res.headers['content-type'] || 'video/mp4' });
					item.urlVideoPreload = URL.createObjectURL(blob);
					item.loadingProgress = 100;
					item.loadingBlob = false; // Set to false after setting progress to 100
					item.loadingTimeout = false; // Clear timeout flag on success
					
				} catch (error) {
					// Clear timeout and progress monitor on error
					if (timeoutId) {
						clearTimeout(timeoutId);
					}
					if (progressMonitor) {
						clearInterval(progressMonitor);
					}
					
					// Check if it's a 404 error and mark as failed
					if (error.message && error.message.includes('404')) {
						this.failedVideos.add(item.id || item.uuid);

					}
					
					throw error;
				}
			},
			
			async loadLargeVideoAsBlob(item, videoUrl, timeoutId, progressMonitor) {
				try {
					// Use the enhanced helper with range requests and progress tracking
					const res = await this.$Helper.loadVideoBlobWithProgress(videoUrl, (progress, loaded, total) => {
						item.loadingProgress = progress;
						
						// Clear timeout if we're making progress
						if (progress > 0 && timeoutId) {
							clearTimeout(timeoutId);
							timeoutId = null;
						}
					});
					
					// Clear any remaining timeout and progress monitor
					if (timeoutId) {
						clearTimeout(timeoutId);
					}
					if (progressMonitor) {
						clearInterval(progressMonitor);
					}
					
					// Create blob from response data
					const blob = new Blob([res.data], { type: res.headers['content-type'] || 'video/mp4' });
					item.urlVideoPreload = URL.createObjectURL(blob);
					item.loadingProgress = 100;
					item.loadingBlob = false; // Set to false after setting progress to 100
					item.loadingTimeout = false; // Clear timeout flag on success
					
				} catch (error) {
					// Clear timeout and progress monitor on error
					if (timeoutId) {
						clearTimeout(timeoutId);
					}
					if (progressMonitor) {
						clearInterval(progressMonitor);
					}
					
					// Check if it's a 404 error and mark as failed
					if (error.message && error.message.includes('404')) {
						this.failedVideos.add(item.id || item.uuid);

					}
					
					throw error;
				}
			},
			
		}, // methods
	}
</script>